import { render, staticRenderFns } from "./PgaDateField.vue?vue&type=template&id=509bc068&"
import script from "./PgaDateField.vue?vue&type=script&lang=ts&"
export * from "./PgaDateField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('509bc068')) {
      api.createRecord('509bc068', component.options)
    } else {
      api.reload('509bc068', component.options)
    }
    module.hot.accept("./PgaDateField.vue?vue&type=template&id=509bc068&", function () {
      api.rerender('509bc068', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inputs/PgaDateField.vue"
export default component.exports